import { render, staticRenderFns } from "./createWeChatDia.vue?vue&type=template&id=2afd2148&scoped=true&"
import script from "./createWeChatDia.vue?vue&type=script&lang=js&"
export * from "./createWeChatDia.vue?vue&type=script&lang=js&"
import style0 from "./createWeChatDia.vue?vue&type=style&index=0&id=2afd2148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd2148",
  null
  
)

export default component.exports